"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5181],{

/***/ 75181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ finance; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useDebounce.tsx


var useDebounce = function(delay) {
    return (0,react.useCallback)((0,lodash.debounce)(function(f) {
        return f();
    }, delay), []);
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./reusable/popups/PopUp.tsx
var PopUp = __webpack_require__(24184);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slider/Slider.js + 1 modules
var Slider = __webpack_require__(59122);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(40922);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/InfoOutlined.js
var InfoOutlined = __webpack_require__(55761);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/sliders/FinanceSlider.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  width: 100%;\n  ",
        " {\n    height: 85px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 1px;\n\n  ",
        " {\n    display: grid;\n    grid-template-columns: 150px 315px 225px;\n    grid-gap: 30px;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "OENaPro";\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 140%;\n\n  display: flex;\n  align-items: center;\n  text-align: right;\n\n  color: ',
        ";\n\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 132px;\n  height: 45px;\n  .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n    border-color: ",
        ';\n    border-width: 0.5px;\n    border-radius: 3px;\n    border-style: solid;\n  }\n  input {\n    letter-spacing: normal;\n    font-family: "MazdaType", "OENaPro", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 140%;\n    text-align: center;\n    color: ',
        ";\n  }\n  ",
        " {\n    width: 150px;\n    height: 45px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: -20px;\n  margin-bottom: 20px;\n  color: ",
        ';\n  font-family: "MazdaType";\n  ',
        " {\n    top: -10px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 8.5px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 44px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 315px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 130%;\n  margin: 0;\n  color: #616161;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  color: #999999;\n  background-color: transparent;\n  border: none;\n  font-size: 20px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  color: #616161;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  ",
        " {\n    font-family: OENaPro;\n    font-style: normal;\n    font-weight: 300;\n    font-size: 12px;\n    line-height: 130%;\n    text-align: right;\n    color: #616161;\n    max-width: 165px;\n    margin-bottom: 40px;\n    margin-top: -20px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}










var StyledSliderContainer = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).withConfig({
    displayName: "FinanceSlider__StyledSliderContainer",
    componentId: "sc-a1540b9e-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledCont = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinanceSlider__StyledCont",
    componentId: "sc-a1540b9e-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledBetween = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinanceSlider__StyledBetween",
    componentId: "sc-a1540b9e-2"
})(_templateObject2());
var StyledTopText = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).withConfig({
    displayName: "FinanceSlider__StyledTopText",
    componentId: "sc-a1540b9e-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.black;
});
var StyledUnderText = (0,styled_components_browser_esm/* default */.ZP)(TextField/* default */.Z).withConfig({
    displayName: "FinanceSlider__StyledUnderText",
    componentId: "sc-a1540b9e-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.darkGrey;
}, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledUnder = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).withConfig({
    displayName: "FinanceSlider__StyledUnder",
    componentId: "sc-a1540b9e-5"
})(_templateObject5(), function(p) {
    return p.theme.colors.disable;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledDesktopSlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinanceSlider__StyledDesktopSlider",
    componentId: "sc-a1540b9e-6"
})(_templateObject6());
function NumberFormatCustom(props) {
    var inputRef = props.inputRef, onChange = props.onChange, name = props.name, shekel = props.shekel, other = (0,_object_without_properties/* default */.Z)(props, [
        "inputRef",
        "onChange",
        "name",
        "shekel"
    ]);
    var format = function(numStr) {
        if (numStr === "") return "";
        return shekel ? new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "ILS",
            maximumFractionDigits: 0
        }).format(numStr) : numStr + " חודשים";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumberFormatBase */.F7, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        name: name,
        format: format,
        isAllowed: function(values) {
            var floatValue = values.floatValue, value = values.value;
            return value === "" || floatValue >= 0 && floatValue <= (name === "months" ? 999 : 999999);
        },
        getInputRef: inputRef,
        onValueChange: function(values) {
            onChange(values.value);
        },
        thousandSeparator: true
    }));
}
NumberFormatCustom.propTypes = {
    inputRef: (prop_types_default()).func.isRequired,
    name: (prop_types_default()).string.isRequired,
    onChange: (prop_types_default()).func.isRequired
};
var CustomSlider = (0,withStyles/* default */.Z)({
    rail: {
        color: "#E7E7E7",
        opacity: 1,
        height: 2
    },
    track: {
        color: "#4C607E",
        height: 2
    },
    thumb: {
        height: 16,
        width: 16,
        backgroundColor: "#fff",
        border: "2px solid #4C607E",
        marginTop: -7.25,
        marginLeft: -8.25,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3);",
        "&:hover, &$active": {
            boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.3);"
        }
    }
})(Slider/* default */.Z);
var StyledSliderMargin = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinanceSlider__StyledSliderMargin",
    componentId: "sc-a1540b9e-7"
})(_templateObject7());
var StyledDesktopSliderAlign = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinanceSlider__StyledDesktopSliderAlign",
    componentId: "sc-a1540b9e-8"
})(_templateObject8());
var StyledTopTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinanceSlider__StyledTopTextContainer",
    componentId: "sc-a1540b9e-9"
})(_templateObject9());
var StyledOptional = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "FinanceSlider__StyledOptional",
    componentId: "sc-a1540b9e-10"
})(_templateObject10());
var StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "FinanceSlider__StyledButton",
    componentId: "sc-a1540b9e-11"
})(_templateObject11());
var StyledSubHeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FinanceSlider__StyledSubHeaderContainer",
    componentId: "sc-a1540b9e-12"
})(_templateObject12(), function(p) {
    return p.theme.breakpoints.up("md");
});
function FinanceSlider(param) {
    var _low = param.low, low = _low === void 0 ? 0 : _low, _high = param.high, high = _high === void 0 ? 200 : _high, _label = param.label, label = _label === void 0 ? "תשלום ראשון" : _label, shekel = param.shekel, formik = param.formik, id = param.id, handleChange = param.handleChange, disabled = param.disabled, optional = param.optional, toolTipText = param.toolTipText, step = param.step, secondHigh = param.secondHigh;
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var ref = (0,react.useState)(false), isSubHeaderOpen = ref[0], setIsSubHeaderOpen = ref[1];
    var handleSubClick = function() {
        setIsSubHeaderOpen(!isSubHeaderOpen);
    };
    var handleInputChange = function(e) {
        var val = Number(e.target.value.replace("₪", "").replace(/,/g, ""));
        if (val >= high) {
            handleChange(Number(high), id);
            return;
        }
        if (val <= low) {
            handleChange(Number(low), id);
            return;
        }
        handleChange(e.target.value === "" ? "" : val, id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSliderContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCont, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopTextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopText, {
                                        children: [
                                            label,
                                            toolTipText && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                onClick: handleSubClick,
                                                "aria-label": "מידע נוסף",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                    fontSize: "inherit",
                                                    style: {
                                                        color: "#616161",
                                                        fill: "#616161"
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    optional && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOptional, {
                                        children: "אופציונלי"
                                    })
                                ]
                            }),
                            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesktopSliderAlign, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopSlider, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSliderMargin, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider, {
                                                disabled: disabled,
                                                min: id === "defaultMonthlyPayment" ? 0 : low,
                                                max: id === "defaultMonthlyPayment" ? 8000 : id === "endOfPeriodPayment" ? secondHigh : high,
                                                step: step ? step : !shekel ? 12 : 1,
                                                value: formik.values[id] !== undefined ? formik.values[id] : low,
                                                onChange: function(e, val) {
                                                    if (val >= high) {
                                                        handleChange(Number(high), id);
                                                        return;
                                                    }
                                                    if (val <= low) {
                                                        handleChange(Number(low), id);
                                                        return;
                                                    }
                                                    handleChange(val, id);
                                                }
                                            })
                                        }),
                                        shekel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBetween, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                                    children: id === "defaultMonthlyPayment" ? "0" : Math.round(low).toLocaleString("en-US")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                                    children: id === "defaultMonthlyPayment" ? "8,000" : id === "endOfPeriodPayment" ? secondHigh.toLocaleString("en-US") : Math.round(high).toLocaleString("en-US")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBetween, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                                    children: "24"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                                    children: "36"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                                    children: "48"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                                    children: "60"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnderText, {
                                onKeyDown: function(event) {
                                    if (event.key === "Enter") {
                                        handleInputChange(event);
                                    }
                                },
                                disabled: disabled || !shekel,
                                "aria-disabled": disabled || !shekel,
                                value: formik.values[id],
                                onChange: function(text) {
                                    return formik.setFieldValue(id, text);
                                },
                                onBlur: handleInputChange,
                                inputProps: {
                                    name: id,
                                    shekel: shekel,
                                    "aria-labelledby": "input-slider",
                                    "aria-label": "".concat(label)
                                },
                                InputProps: {
                                    inputComponent: NumberFormatCustom
                                }
                            })
                        ]
                    }),
                    !isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            toolTipText && isSubHeaderOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubHeaderContainer, {
                                children: toolTipText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSliderMargin, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider, {
                                    disabled: disabled,
                                    min: low,
                                    max: high,
                                    step: !shekel ? 12 : 1,
                                    value: formik.values[id],
                                    onChange: function(e, val) {
                                        return handleChange(val, id);
                                    }
                                })
                            }),
                            shekel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBetween, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                        children: Math.round(low).toLocaleString("en-US")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                        children: Math.round(high).toLocaleString("en-US")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBetween, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                        children: "24"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                        children: "36"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                        children: "48"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUnder, {
                                        children: "60"
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            isDesktop && toolTipText && isSubHeaderOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubHeaderContainer, {
                children: toolTipText
            })
        ]
    });
}

// EXTERNAL MODULE: ./store.ts + 2 modules
var store = __webpack_require__(13328);
// EXTERNAL MODULE: ./api/generated/MazdaApi.ts
var MazdaApi = __webpack_require__(46092);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
;// CONCATENATED MODULE: ./reusable/finance/BottomActions.tsx

function BottomActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    BottomActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BottomActions_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  grid-gap: 10px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 24px;\n  button {\n    width: 100%;\n  }\n  ",
        " {\n    flex-direction: row;\n    margin-top: 0px;\n    button {\n      width: auto;\n    }\n  }\n"
    ]);
    BottomActions_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BottomActions_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  letter-spacing: 0.05em;\n  color: ",
        ";\n  padding: 0px;\n  height: 19px;\n  border-bottom: 2px solid ",
        ";\n  align-self: center;\n  cursor: pointer;\n"
    ]);
    BottomActions_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledActionsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BottomActions__StyledActionsContainer",
    componentId: "sc-4e120e5a-0"
})(BottomActions_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BottomActions__StyledButtons",
    componentId: "sc-4e120e5a-1"
})(BottomActions_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledTermsAction = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "BottomActions__StyledTermsAction",
    componentId: "sc-4e120e5a-2"
})(BottomActions_templateObject2(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.colors.black;
});
function BottomActions(param) {
    var onTermsOpen = param.onTermsOpen, onCopyOpen = param.onCopyOpen, onContactOpen = param.onContactOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActionsContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTermsAction, {
                onClick: onTermsOpen,
                children: "לתנאים ותקנון"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtons, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outlined",
                        onClick: onCopyOpen,
                        disableFocusRipple: false,
                        disableRipple: false,
                        children: "לשתף את ההצעה"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onContactOpen,
                        disableFocusRipple: false,
                        disableRipple: false,
                        children: "חזרו אליי לגבי ההצעה"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var finance_BottomActions = (BottomActions);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
;// CONCATENATED MODULE: ./reusable/finance/LoanDetails.tsx

function LoanDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 10px 10px 20px;\n  gap: 30px;\n\n  background: ",
        ";\n  border-radius: 3px;\n  margin-bottom: 30px;\n"
    ]);
    LoanDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LoanDetails_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    LoanDetails_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LoanDetails_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 42px;\n"
    ]);
    LoanDetails_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LoanDetails_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 140%;\n\n  text-align: center;\n\n  color: ",
        ";\n  ",
        " {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22.4px;\n  }\n"
    ]);
    LoanDetails_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LoanDetails_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 15.6px;\n  }\n"
    ]);
    LoanDetails_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LoanDetails_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 140%;\n  color: #101010;\n  margin-bottom: 20px;\n"
    ]);
    LoanDetails_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LoanDetails_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px 10px;\n"
    ]);
    LoanDetails_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var StyledModelBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LoanDetails__StyledModelBox",
    componentId: "sc-21ce2fc0-0"
})(LoanDetails_templateObject(), function(p) {
    return p.theme.colors.lightGrey;
});
var StyledModelDataContainerBottom = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LoanDetails__StyledModelDataContainerBottom",
    componentId: "sc-21ce2fc0-1"
})(LoanDetails_templateObject1());
var StyledModelDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LoanDetails__StyledModelDetail",
    componentId: "sc-21ce2fc0-2"
})(LoanDetails_templateObject2());
var DetailText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "LoanDetails__DetailText",
    componentId: "sc-21ce2fc0-3"
})(LoanDetails_templateObject3(), constants/* Font.MazdaType */.Zx.MazdaType, function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var DetailTextHeader = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "LoanDetails__DetailTextHeader",
    componentId: "sc-21ce2fc0-4"
})(LoanDetails_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "h3"
}).withConfig({
    displayName: "LoanDetails__StyledTitle",
    componentId: "sc-21ce2fc0-5"
})(LoanDetails_templateObject5());
var StyledModelDetailPadding = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "LoanDetails__StyledModelDetailPadding",
    componentId: "sc-21ce2fc0-6"
})(LoanDetails_templateObject6());
function LoanDetails(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                tabIndex: 0,
                children: "סיכום מסלול המימון"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelDataContainerBottom, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelDetailPadding, {
                        children: data.map(function(item, index) {
                            var ref, ref1;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModelDetail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailTextHeader, {
                                                children: item.label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailText, {
                                                children: item.withShekel ? "₪".concat(item === null || item === void 0 ? void 0 : (ref = item.value) === null || ref === void 0 ? void 0 : ref.toLocaleString()) : "".concat(item === null || item === void 0 ? void 0 : (ref1 = item.value) === null || ref1 === void 0 ? void 0 : ref1.toString(), " חודשים ")
                                            })
                                        ]
                                    }),
                                    index !== data.length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        style: {
                                            width: "100%",
                                            backgroundColor: "#E7E7E7",
                                            height: "1px"
                                        }
                                    }) : null
                                ]
                            }, index.toString());
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var finance_LoanDetails = (LoanDetails);

// EXTERNAL MODULE: ./reusable/formsComp/FormSelect.tsx + 1 modules
var FormSelect = __webpack_require__(83225);
;// CONCATENATED MODULE: ./reusable/finance/TopModelDetails.tsx

function TopModelDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    TopModelDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "MazdaType";\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n\n  text-align: center;\n  letter-spacing: 0.06em;\n\n  color: ',
        ";\n  margin: 10px 0;\n  ",
        " {\n    font-weight: 500;\n    font-size: 32px;\n    line-height: 44.8px;\n    letter-spacing: 1.11;\n  }\n"
    ]);
    TopModelDetails_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 10px 10px 20px;\n  gap: 30px;\n\n  background: ",
        ";\n  border-radius: 3px;\n  margin-bottom: 30px;\n"
    ]);
    TopModelDetails_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 16px;\n  ",
        " {\n    grid-gap: 30px;\n  }\n"
    ]);
    TopModelDetails_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 280px;\n  height: 129px;\n  object-fit: cover;\n  align-self: center;\n  ",
        " {\n    width: 293px;\n    object-fit: cover;\n  }\n"
    ]);
    TopModelDetails_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        " {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 67px;\n  }\n"
    ]);
    TopModelDetails_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 42px;\n"
    ]);
    TopModelDetails_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-family: "MazdaType";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 140%;\n\n  text-align: center;\n\n  color: ',
        ";\n  ",
        " {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22.4px;\n  }\n"
    ]);
    TopModelDetails_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  color: ",
        ";\n\n  ",
        " {\n    font-size: 12px;\n    font-weight: 300;\n    line-height: 15.6px;\n  }\n"
    ]);
    TopModelDetails_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function TopModelDetails_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px 10px;\n"
    ]);
    TopModelDetails_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var StyledModelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopModelDetails__StyledModelContainer",
    componentId: "sc-418ff1d1-0"
})(TopModelDetails_templateObject());
var StyledModelHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    displayName: "TopModelDetails__StyledModelHeader",
    componentId: "sc-418ff1d1-1"
})(TopModelDetails_templateObject1(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var TopModelDetails_StyledModelBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopModelDetails__StyledModelBox",
    componentId: "sc-418ff1d1-2"
})(TopModelDetails_templateObject2(), function(p) {
    return p.theme.colors.lightGrey;
});
var StyledSelectGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopModelDetails__StyledSelectGrid",
    componentId: "sc-418ff1d1-3"
})(TopModelDetails_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledModelImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "TopModelDetails__StyledModelImage",
    componentId: "sc-418ff1d1-4"
})(TopModelDetails_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledModelDataContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopModelDetails__StyledModelDataContainer",
    componentId: "sc-418ff1d1-5"
})(TopModelDetails_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var TopModelDetails_StyledModelDetail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopModelDetails__StyledModelDetail",
    componentId: "sc-418ff1d1-6"
})(TopModelDetails_templateObject6());
var TopModelDetails_DetailText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "TopModelDetails__DetailText",
    componentId: "sc-418ff1d1-7"
})(TopModelDetails_templateObject7(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var TopModelDetails_DetailTextHeader = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "TopModelDetails__DetailTextHeader",
    componentId: "sc-418ff1d1-8"
})(TopModelDetails_templateObject8(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var TopModelDetails_StyledModelDetailPadding = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TopModelDetails__StyledModelDetailPadding",
    componentId: "sc-418ff1d1-9"
})(TopModelDetails_templateObject9());
function TopModelDetails(param) {
    var modelName = param.modelName, formik = param.formik, engines = param.engines, finishingLevels = param.finishingLevels, selected = param.selected;
    var ref, ref1, ref2, ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModelContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelHeader, {
                children: modelName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_StyledModelBox, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm.FormikProvider, {
                        value: formik,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSelectGrid, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                    name: "engineId",
                                    label: "בחירת מנוע",
                                    values: engines,
                                    map: function(item) {
                                        return {
                                            id: item === null || item === void 0 ? void 0 : item.engineId,
                                            name: item === null || item === void 0 ? void 0 : item.engineName
                                        };
                                    },
                                    title: "engineId"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                    name: "finishingLevel",
                                    label: "בחירת רמת גימור",
                                    values: finishingLevels,
                                    map: function(item) {
                                        return {
                                            id: item === null || item === void 0 ? void 0 : item.name,
                                            name: item === null || item === void 0 ? void 0 : item.name
                                        };
                                    },
                                    title: "finishingLevel"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModelDataContainer, {
                        tabIndex: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModelImage, {
                                src: selected === null || selected === void 0 ? void 0 : (ref = selected.image) === null || ref === void 0 ? void 0 : ref.imageUrl,
                                alt: (selected === null || selected === void 0 ? void 0 : (ref1 = selected.image) === null || ref1 === void 0 ? void 0 : ref1.alt) || "car model details"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_StyledModelDetailPadding, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_StyledModelDetail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopModelDetails_DetailTextHeader, {
                                                children: "מחיר (כולל מע״מ)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_DetailText, {
                                                children: [
                                                    "₪",
                                                    selected === null || selected === void 0 ? void 0 : (ref2 = selected.price) === null || ref2 === void 0 ? void 0 : ref2.toLocaleString()
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        style: {
                                            width: "100%",
                                            backgroundColor: "#E7E7E7",
                                            height: "1px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_StyledModelDetail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopModelDetails_DetailTextHeader, {
                                                children: "אגרת רישוי"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_DetailText, {
                                                children: [
                                                    "₪",
                                                    selected === null || selected === void 0 ? void 0 : (ref3 = selected.licenceFee) === null || ref3 === void 0 ? void 0 : ref3.toLocaleString()
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        style: {
                                            width: "100%",
                                            backgroundColor: "#E7E7E7",
                                            height: "1px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_StyledModelDetail, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopModelDetails_DetailTextHeader, {
                                                children: "סה״כ מחיר רכב"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopModelDetails_DetailText, {
                                                style: {
                                                    fontSize: "24px"
                                                },
                                                children: [
                                                    "₪",
                                                    (ref4 = (selected === null || selected === void 0 ? void 0 : selected.price) + (selected === null || selected === void 0 ? void 0 : selected.licenceFee)) === null || ref4 === void 0 ? void 0 : ref4.toLocaleString()
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var finance_TopModelDetails = (TopModelDetails);

;// CONCATENATED MODULE: ./reusable/finance/utils.ts

// Calculations for loan
function calculate(pr, int, mo) {
    // Get the user's input from the form. Assume it is all valid.
    // Convert interest from a percentage to a decimal, and convert from
    // an annual rate to a monthly rate. Convert payment period in years
    // to the number of monthly payments.
    var principal = pr;
    var interest = int / 100 / 12;
    var payments = mo;
    // Now compute the monthly payment figure, using esoteric math.
    var x = Math.pow(1 + interest, payments);
    var monthly = principal * x * interest / (x - 1);
    // Check that the result is a finite number. If so, display the results.
    return (0,lodash.round)(monthly);
// Otherwise, the user's input was probably invalid, so don't
// display anything.
}
//Calculates loan amount using by months with monthly payment
function calculateLoanAmount(monthlyPayment, annualInterestRate, loanTermInYears) {
    var monthlyInterestRate = annualInterestRate / 12 / 100;
    var totalNumberOfPayments = loanTermInYears * 12;
    var presentValue = monthlyPayment * ((1 - Math.pow(1 + monthlyInterestRate, -totalNumberOfPayments)) / monthlyInterestRate);
    return presentValue;
}
function isBetween(value, first, last) {
    var lower = Math.min(first, last), upper = Math.max(first, last);
    return value >= lower && value <= upper;
}

;// CONCATENATED MODULE: ./reusable/finance/index.tsx




function finance_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    finance_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var CopyPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8105).then(__webpack_require__.bind(__webpack_require__, 98105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98105)
            ];
        }
    },
    ssr: false
});
var TermsPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8673).then(__webpack_require__.bind(__webpack_require__, 38673));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38673)
            ];
        }
    },
    ssr: false
});
var ContactPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9478).then(__webpack_require__.bind(__webpack_require__, 59478));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59478)
            ];
        }
    },
    ssr: false
});
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "finance__StyledContainer",
    componentId: "sc-21ecf320-0"
})(finance_templateObject());
var prepayPrecent = 0.3;
var baloonPrecent = 0.5;
var Finance = function(param) {
    var modelName = param.modelName, modelId = param.modelId, popupOpen = param.popupOpen, setPopupOpen = param.setPopupOpen, onlyClick = param.onlyClick;
    var debounce = useDebounce(1000);
    var router = (0,next_router.useRouter)();
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    //Need those 3 properties for the configurator page
    var selectedColorCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var selectedUpholsteryCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.upholstery;
    }).selectedUpholsteryCode;
    var selectedDetailingCode = (0,store/* useTypedSelector */.ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var state = (0,store/* useTypedSelector */.ix)(function(state) {
        return state;
    });
    var ref = (0,next_router.useRouter)(), query = ref.query, isReady = ref.isReady, asPath = ref.asPath;
    var ref1 = (0,react.useState)(false), termsPopupOpen = ref1[0], setTermsPopupOpen = ref1[1];
    var ref2 = (0,react.useState)(false), copyPopupOpen = ref2[0], setCopyPopupOpen = ref2[1];
    var ref3 = (0,react.useState)(false), contactPopupOpen = ref3[0], setContactPopupOpen = ref3[1];
    var ref4 = (0,react.useState)([]), engines = ref4[0], setEngines = ref4[1];
    var ref5 = (0,react.useState)([]), finishingLevels = ref5[0], setFinishingLevels = ref5[1];
    var ref6 = (0,react.useState)(null), selectedEngineId = ref6[0], setSelectedEngineId = ref6[1];
    var shopEngines = state.detailing.engines.map(function(item) {
        return Object.assign({}, item, {
            engineName: item.engineIdName
        });
    });
    var ref7 = (0,react.useState)({
        defaultMonthlyPayment: 0,
        defaultPrePay: 0,
        interest: 0,
        primeInterest: 0,
        months: 60,
        endOfPeriodPayment: 0,
        primeMargin: 0
    }), initialValues = ref7[0];
    //formik for finance calculator
    var formik = (0,formik_esm.useFormik)({
        initialValues: initialValues,
        onSubmit: function() {}
    });
    var ref8 = (0,react.useState)({
        engineId: 0,
        finishingLevel: ""
    }), selectInitialValues = ref8[0];
    //formik for saving dropdown state
    var selectFormik = (0,formik_esm.useFormik)({
        initialValues: selectInitialValues,
        onSubmit: function() {}
    });
    //Changing query on any property change
    var changeQuery = (0,react.useCallback)(function() {
        var queryParams = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
            defaultMonthlyPayment: formik.values.defaultMonthlyPayment,
            defaultPrePay: formik.values.defaultPrePay,
            months: formik.values.months,
            endOfPeriodPayment: formik.values.endOfPeriodPayment,
            finishingLevel: selectFormik.values.finishingLevel,
            engineId: selectFormik.values.engineId,
            color: selectedColorCode || "",
            upholstery: selectedUpholsteryCode || "",
            detailing: selectedDetailingCode || "",
            loaded: true
        });
        var queryString = Object.keys(queryParams).reduce(function(accum, item, i) {
            if (i === 0) return "".concat(item, "=").concat(queryParams[item]);
            return "".concat(accum, "&").concat(item, "=").concat(queryParams[item]);
        }, "");
        var newUrl = router.asPath.split("?")[0] + "?" + queryString + window.location.hash;
        router.replace(newUrl, null, {
            shallow: true
        });
        return null;
    }, [
        formik.values.defaultMonthlyPayment,
        formik.values.defaultPrePay,
        formik.values.endOfPeriodPayment,
        formik.values.months,
        selectFormik.values.engineId,
        selectFormik.values.finishingLevel, 
    ]);
    // Returns true if you're in the configurator / shop
    var isShop = function() {
        return router.asPath.split("?")[0].indexOf("shop") > -1;
    };
    (0,react.useEffect)(function() {
        //If the popup is open fetch and set data
        if (isReady) {
            (0,MazdaApi/* getCarmodelCalculator */.WU)(modelId).then(function(res) {
                var ref, ref1;
                setEngines(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.body) === null || ref1 === void 0 ? void 0 : ref1.engines);
                if (query.engineId && query.finishingLevel && !query.defaultMonthlyPayment) {
                    var ref2, ref3, ref4;
                    selectFormik.setFieldValue("engineId", (ref4 = res === null || res === void 0 ? void 0 : (ref2 = res.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.body) === null || ref3 === void 0 ? void 0 : ref3.engines.find(function(item) {
                        return item.engineId === Number(query.engineId);
                    })) === null || ref4 === void 0 ? void 0 : ref4.engineId);
                } else {
                    var ref5, ref6, ref7, ref8, ref9;
                    if (isShop()) {
                        var ref10;
                        var engineId = (ref10 = shopEngines.find(function(engine) {
                            return engine.finishingLevels.some(function(detailing) {
                                return detailing.details.code === selectedDetailingCode;
                            });
                        })) === null || ref10 === void 0 ? void 0 : ref10.engineId;
                        setSelectedEngineId(engineId);
                        selectFormik.setFieldValue("engineId", engineId);
                        return;
                    }
                    selectFormik.setFieldValue("engineId", ((ref7 = res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.body) === null || ref6 === void 0 ? void 0 : ref6.engines.find(function(item) {
                        return item.engineId === selectFormik.values.engineId || item.engineId === Number(query.engineId);
                    })) === null || ref7 === void 0 ? void 0 : ref7.engineId) || (res === null || res === void 0 ? void 0 : (ref8 = res.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.body) === null || ref9 === void 0 ? void 0 : ref9.engines[0].engineId));
                }
            });
        }
        // If user redirects from outside page and wants to open popup automatically
        if (isReady && (query === null || query === void 0 ? void 0 : query.openPopup)) {
            setPopupOpen(true);
        }
    }, [
        isReady,
        query === null || query === void 0 ? void 0 : query.engineId,
        selectedDetailingCode
    ]);
    (0,react.useEffect)(function() {
        //If the engines are set find and set finishingLevel that is selected outside of the component or default
        if (engines && engines.length) {
            var ref, ref1;
            if (isShop() && !selectedEngineId) return;
            var selectedFinish = isShop() ? (ref = engines.find(function(item) {
                return item.engineId === selectedEngineId;
            })) === null || ref === void 0 ? void 0 : ref.finishingLevels : (ref1 = engines.find(function(item) {
                return item.engineId === selectFormik.values.engineId;
            })) === null || ref1 === void 0 ? void 0 : ref1.finishingLevels;
            setFinishingLevels(selectedFinish);
            if (query.engineId && query.finishingLevel && !query.defaultMonthlyPayment) {
                var ref2;
                selectFormik.setFieldValue("finishingLevel", (ref2 = selectedFinish === null || selectedFinish === void 0 ? void 0 : selectedFinish.find(function(item) {
                    return item.name === query.finishingLevel || item.code === query.finishingLevel;
                })) === null || ref2 === void 0 ? void 0 : ref2.name);
            } else {
                var ref3;
                if (isShop()) {
                    var ref4;
                    selectFormik.setFieldValue("finishingLevel", (ref4 = selectedFinish.find(function(item) {
                        return item.code === selectedDetailingCode;
                    })) === null || ref4 === void 0 ? void 0 : ref4.name);
                    return;
                }
                selectFormik.setFieldValue("finishingLevel", ((ref3 = selectedFinish === null || selectedFinish === void 0 ? void 0 : selectedFinish.find(function(item) {
                    return item.name === query.finishingLevel || item.code === query.finishingLevel;
                })) === null || ref3 === void 0 ? void 0 : ref3.name) || (selectedFinish === null || selectedFinish === void 0 ? void 0 : selectedFinish[0].name));
            }
        }
    }, [
        selectFormik.values.engineId,
        engines,
        query.finishingLevel,
        selectedDetailingCode, 
    ]);
    var ref9 = (0,react.useState)(0), maxMonthly = ref9[0], setMaxMonthly = ref9[1];
    var ref10 = (0,react.useState)(0), minMonthly = ref10[0], setMinMonthly = ref10[1];
    (0,react.useEffect)(function() {
        //If popup opens or formik values change call changequery and set query values
        if (formik.values && popupOpen) {
            debounce(changeQuery);
        }
    }, [
        formik.values.defaultMonthlyPayment,
        formik.values.defaultPrePay,
        formik.values.months,
        formik.values.endOfPeriodPayment,
        selectFormik.values.finishingLevel,
        selectFormik.values.engineId, 
    ]);
    //Selected finishing level
    var selected = (0,react.useMemo)(function() {
        return finishingLevels.find(function(item) {
            return item.name === selectFormik.values.finishingLevel;
        }) || {};
    }, [
        finishingLevels,
        selectFormik.values.finishingLevel
    ]);
    //If interest values are set and finishing level is selected calculate different options of values for selected months
    (0,react.useEffect)(function() {
        if (formik.values.primeInterest && formik.values.primeMargin && selected) {
            var loanPercentage = formik.values.primeMargin + formik.values.primeInterest;
            //Calculate maximum monthly payment
            var maximumMonthly = calculate(selected.price, loanPercentage, formik.values.months);
            var minimumMonthly = calculate(20000 - formik.values.endOfPeriodPayment, loanPercentage, formik.values.months) + formik.values.endOfPeriodPayment * (loanPercentage / 12 / 100);
            setMaxMonthly(maximumMonthly);
            setMinMonthly(minimumMonthly);
        }
    }, [
        formik.values.endOfPeriodPayment,
        formik.values.months,
        formik.values.primeInterest,
        formik.values.primeMargin,
        selected, 
    ]);
    // If popup isn't loaded and url comes with defaultMonthlyPayment set initial values as it comes.
    var handleInitialQueryData = (0,react.useCallback)(function() {
        if (!query.loaded && query.defaultMonthlyPayment && !onlyClick) {
            var ref, ref1;
            formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), {
                defaultMonthlyPayment: Number(query === null || query === void 0 ? void 0 : query.defaultMonthlyPayment),
                defaultPrePay: Number(query === null || query === void 0 ? void 0 : query.defaultPrePay),
                months: Number(query === null || query === void 0 ? void 0 : query.months),
                endOfPeriodPayment: Number(query === null || query === void 0 ? void 0 : query.endOfPeriodPayment),
                primeInterest: selected === null || selected === void 0 ? void 0 : (ref = selected.calculator) === null || ref === void 0 ? void 0 : ref.primeInterest,
                primeMargin: selected === null || selected === void 0 ? void 0 : (ref1 = selected.calculator) === null || ref1 === void 0 ? void 0 : ref1.primeMargin
            }));
            router.replace({
                pathname: router.asPath.split("?")[0],
                query: {
                    loaded: true
                }
            });
            setPopupOpen(true);
        }
    }, [
        selected.calculator,
        onlyClick,
        query === null || query === void 0 ? void 0 : query.defaultMonthlyPayment,
        query === null || query === void 0 ? void 0 : query.defaultPrePay,
        query === null || query === void 0 ? void 0 : query.endOfPeriodPayment,
        query.loaded,
        query === null || query === void 0 ? void 0 : query.months,
        router,
        setPopupOpen, 
    ]);
    var handleChange = (0,react.useCallback)(function(val, id) {
        var loanPercentage = formik.values.primeMargin + formik.values.primeInterest;
        switch(id){
            case "defaultPrePay":
                {
                    var _endOfPeriodPayment;
                    var loanTotal = selected.price - ((_endOfPeriodPayment = formik.values.endOfPeriodPayment) !== null && _endOfPeriodPayment !== void 0 ? _endOfPeriodPayment : 0) - (val !== null && val !== void 0 ? val : 0);
                    var _obj;
                    formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), (_obj = {}, (0,_define_property/* default */.Z)(_obj, id, Number(val)), (0,_define_property/* default */.Z)(_obj, "defaultMonthlyPayment", (0,lodash.ceil)(calculate(loanTotal, loanPercentage, formik.values.months) + formik.values.endOfPeriodPayment * (loanPercentage / 12 / 100))), (0,_define_property/* default */.Z)(_obj, "endOfPeriodPayment", selected.price - Number(val) <= formik.values.endOfPeriodPayment ? selected.price - Number(val) - 2000 <= 20000 ? 18000 : selected.price - Number(val) - 2000 : formik.values.endOfPeriodPayment), _obj)));
                    break;
                }
            case "endOfPeriodPayment":
                {
                    var _defaultPrePay;
                    var loanTotal1 = selected.price - Number(val) - ((_defaultPrePay = formik.values.defaultPrePay) !== null && _defaultPrePay !== void 0 ? _defaultPrePay : 0);
                    var _obj1;
                    formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, id, Number(val)), (0,_define_property/* default */.Z)(_obj1, "defaultMonthlyPayment", (0,lodash.ceil)(calculate(loanTotal1, loanPercentage, formik.values.months) + Number(val) * (loanPercentage / 12 / 100))), _obj1)));
                    break;
                }
            case "months":
                {
                    var _endOfPeriodPayment1, _defaultPrePay1;
                    var loanTotal2 = selected.price - ((_endOfPeriodPayment1 = formik.values.endOfPeriodPayment) !== null && _endOfPeriodPayment1 !== void 0 ? _endOfPeriodPayment1 : 0) - ((_defaultPrePay1 = formik.values.defaultPrePay) !== null && _defaultPrePay1 !== void 0 ? _defaultPrePay1 : 0);
                    var _obj2;
                    formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, id, Number(val)), (0,_define_property/* default */.Z)(_obj2, "defaultMonthlyPayment", (0,lodash.ceil)(calculate(loanTotal2, loanPercentage, Number(val)) + formik.values.endOfPeriodPayment * (loanPercentage / 12 / 100))), _obj2)));
                    break;
                }
            case "defaultMonthlyPayment":
                {
                    var _endOfPeriodPayment2;
                    var loanTotal3 = selected.price - ((_endOfPeriodPayment2 = formik.values.endOfPeriodPayment) !== null && _endOfPeriodPayment2 !== void 0 ? _endOfPeriodPayment2 : 0);
                    var presentVal = calculateLoanAmount(val, loanPercentage, formik.values.months / 12);
                    var prePay = loanTotal3 - (0,lodash.round)(presentVal, -2);
                    if (!(val >= maxMonthly || val <= minMonthly)) {
                        var _obj3;
                        formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), (_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, id, Number(val)), (0,_define_property/* default */.Z)(_obj3, "defaultPrePay", prePay <= 0 ? 0 : prePay), (0,_define_property/* default */.Z)(_obj3, "endOfPeriodPayment", prePay <= 0 ? 0 : formik.values.endOfPeriodPayment), _obj3)));
                    } else if (val >= maxMonthly && formik.values[id] !== maxMonthly) {
                        var _obj4;
                        formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), (_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, id, Number(maxMonthly)), (0,_define_property/* default */.Z)(_obj4, "defaultPrePay", prePay <= 0 ? 0 : prePay), (0,_define_property/* default */.Z)(_obj4, "endOfPeriodPayment", prePay <= 0 ? 0 : formik.values.endOfPeriodPayment), _obj4)));
                    } else if (val <= minMonthly && formik.values[id] !== minMonthly) {
                        var _obj5;
                        formik.setValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formik.values), (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, id, Number(minMonthly)), (0,_define_property/* default */.Z)(_obj5, "defaultPrePay", prePay <= 0 ? 0 : prePay), (0,_define_property/* default */.Z)(_obj5, "endOfPeriodPayment", prePay <= 0 ? 0 : formik.values.endOfPeriodPayment), _obj5)));
                    }
                    break;
                }
        }
    }, [
        formik.values.defaultPrePay,
        formik.values.defaultMonthlyPayment,
        formik.values.endOfPeriodPayment,
        formik.values.months,
        finishingLevels,
        maxMonthly,
        minMonthly,
        selectFormik.values.finishingLevel,
        selected.price, 
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (selected === null || selected === void 0 ? void 0 : (ref = selected.calculator) === null || ref === void 0 ? void 0 : ref.defaultMonthlyPayment) {
            var ref1, ref2, ref3, ref4;
            var _endOfPeriodPayment;
            var loanTotal = selected.price - ((_endOfPeriodPayment = formik.values.endOfPeriodPayment) !== null && _endOfPeriodPayment !== void 0 ? _endOfPeriodPayment : 0);
            var presentVal = calculateLoanAmount(selected === null || selected === void 0 ? void 0 : (ref1 = selected.calculator) === null || ref1 === void 0 ? void 0 : ref1.defaultMonthlyPayment, (selected === null || selected === void 0 ? void 0 : (ref2 = selected.calculator) === null || ref2 === void 0 ? void 0 : ref2.primeInterest) + (selected === null || selected === void 0 ? void 0 : (ref3 = selected.calculator) === null || ref3 === void 0 ? void 0 : ref3.primeMargin), formik.values.months / 12);
            var prePay = loanTotal - (0,lodash.ceil)(presentVal);
            var ref5;
            var modifiedCalculator = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected.calculator), {
                defaultMonthlyPayment: (ref5 = selected === null || selected === void 0 ? void 0 : (ref4 = selected.calculator) === null || ref4 === void 0 ? void 0 : ref4.defaultMonthlyPayment) !== null && ref5 !== void 0 ? ref5 : 0,
                defaultPrePay: prePay
            });
            formik.setValues((0,_object_spread/* default */.Z)({}, formik.values, modifiedCalculator));
        } else {
            var ref6, ref7, ref8;
            var prepayByPrice = prepayPrecent ? selected.price * prepayPrecent : selected === null || selected === void 0 ? void 0 : (ref6 = selected.calculator) === null || ref6 === void 0 ? void 0 : ref6.defaultPrePay;
            var baloonByPrice = baloonPrecent ? selected.price * baloonPrecent : 0;
            var loanTotal1 = selected.price - prepayByPrice - baloonByPrice;
            var modifiedCalculator1 = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selected.calculator), {
                defaultMonthlyPayment: (0,lodash.ceil)(calculate(loanTotal1, (selected === null || selected === void 0 ? void 0 : (ref7 = selected.calculator) === null || ref7 === void 0 ? void 0 : ref7.primeInterest) + (selected === null || selected === void 0 ? void 0 : (ref8 = selected.calculator) === null || ref8 === void 0 ? void 0 : ref8.primeMargin), 36)),
                defaultPrePay: prepayByPrice,
                endOfPeriodPayment: baloonByPrice
            });
            formik.setValues((0,_object_spread/* default */.Z)({}, formik.values, modifiedCalculator1));
        }
    }, [
        selectFormik.values.finishingLevel,
        selectFormik.values.engineId,
        isReady, 
    ]);
    (0,react.useEffect)(function() {
        if (selected && (query === null || query === void 0 ? void 0 : query.openPopup) && (query === null || query === void 0 ? void 0 : query.defaultMonthlyPayment)) {
            // If user goes from popup to summary
            if (isReady) {
                handleInitialQueryData();
            }
            router.replace({
                pathname: router.asPath.split("?")[0],
                query: {
                    loaded: true
                }
            });
        }
    }, [
        isReady
    ]);
    var handleCopyOpen = (0,react.useCallback)(function() {
        if (isDesktop) {
            setPopupOpen(false);
            setCopyPopupOpen(true);
            changeQuery();
        } else {
            changeQuery();
            navigator === null || navigator === void 0 ? void 0 : navigator.share({
                text: copyText,
                url: link
            });
        }
    }, [
        changeQuery,
        setPopupOpen
    ]);
    var handleTermsOpen = (0,react.useCallback)(function() {
        setPopupOpen(false);
        setTermsPopupOpen(true);
    }, [
        setPopupOpen
    ]);
    var handleContactOpen = (0,react.useCallback)(function() {
        setPopupOpen(false);
        setContactPopupOpen(true);
        (0,analytics/* trackPopUpOpen */.W1)("Finance suggestion");
    }, [
        setPopupOpen
    ]);
    var copyText = "".concat(modelName, " ").concat(selectFormik.values.finishingLevel, "\n בהצעת מימון בהתאמה אישית");
    var link = (0,react.useMemo)(function() {
        return "https://www.mazda.co.il" + (asPath.split("?")[0] + "?openPopup=true&" + asPath.split("?")[1]).replace("loaded=true", "");
    }, [
        asPath
    ]);
    var constumClose = (0,react.useCallback)(function() {
    //Temporarily removed needs testing, this makes model page jump to top.
    // if (!router.asPath.includes("shop")) {
    //   router.replace(router.asPath.split("?")[0]) + window.location.hash
    // }
    }, [
        router
    ]);
    var description = "שם דגם: ".concat(modelName, "\n\n  חבילת אבזור: ").concat(selectFormik.values.finishingLevel, "\n  גובה מקדמה: ").concat(formik.values.defaultPrePay, "\n  גובה החזר סוף תקופה: ").concat(formik.values.endOfPeriodPayment, "\n  גובה החזר חודשי: ").concat(formik.values.defaultMonthlyPayment, "\n  מספר תשלומים: ").concat(formik.values.months, "\n ");
    var bottomData = (0,react.useMemo)(function() {
        return [
            {
                label: "תשלום חודשי",
                value: formik.values.defaultMonthlyPayment,
                withShekel: true
            },
            {
                label: "תקופת החזר",
                value: formik.values.months,
                withShekel: false
            },
            {
                label: "מקדמה בתחילת תקופה",
                value: formik.values.defaultPrePay,
                withShekel: true
            },
            {
                label: "תשלום סוף תקופה",
                value: formik.values.endOfPeriodPayment,
                withShekel: true
            }, 
        ];
    }, [
        formik.values.defaultMonthlyPayment,
        formik.values.defaultPrePay,
        formik.values.endOfPeriodPayment,
        formik.values.months, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopup, {
                modelId: modelId,
                description: description,
                popupOpen: contactPopupOpen,
                setPopupOpen: setContactPopupOpen,
                customClose: function() {
                    setPopupOpen(true);
                    setContactPopupOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyPopup, {
                link: link,
                copyText: copyText,
                buttonText: "העתקת לינק לשיתוף",
                setCopyPopupOpen: setCopyPopupOpen,
                copyPopupOpen: copyPopupOpen,
                customClose: function() {
                    setCopyPopupOpen(false);
                    setPopupOpen(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsPopup, {
                setTermsPopupOpen: setTermsPopupOpen,
                termsPopupOpen: termsPopupOpen,
                customClose: function() {
                    setTermsPopupOpen(false);
                    setPopupOpen(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUp/* default */.Z, {
                header: "מחשבון מימון",
                subHeader: "במחשבון זה אפשר לבצע סימולציה למסלול המימון המתאים לרכישת המאזדה שלך.\n        יש לבחור את נפח המנוע ואת רמת הגימור, ואז להתאים הצעת מימון גמישה ונוחה.\n        בסיום הבדיקה אפשר להשאיר פרטים, ונציג שלנו ייצור קשר להמשך ייעוץ אישי",
                setOpen: setPopupOpen,
                open: popupOpen,
                maxWidth: "md",
                width: isDesktop ? 750 : 326,
                customClose: function() {
                    setPopupOpen(false);
                    constumClose();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(finance_TopModelDetails, {
                            modelName: modelName,
                            formik: selectFormik,
                            engines: engines,
                            finishingLevels: finishingLevels,
                            selected: selected
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FinanceSlider, {
                            low: minMonthly,
                            high: maxMonthly,
                            shekel: true,
                            label: "החזר חודשי",
                            formik: formik,
                            step: 100,
                            id: "defaultMonthlyPayment",
                            handleChange: handleChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FinanceSlider, {
                            disabled: false,
                            low: 24,
                            high: 60,
                            shekel: false,
                            label: "תקופה",
                            formik: formik,
                            id: "months",
                            handleChange: handleChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FinanceSlider, {
                            low: 0,
                            high: selected.price - 20000,
                            shekel: true,
                            label: "מקדמה",
                            formik: formik,
                            disabled: selected.price - formik.values.defaultMonthlyPayment === 0,
                            id: "defaultPrePay",
                            handleChange: handleChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FinanceSlider, {
                            low: 0,
                            high: (0,lodash.ceil)(selected.price / 2 > selected.price - formik.values.defaultPrePay ? selected.price - formik.values.defaultPrePay - 2000 : selected.price / 2),
                            secondHigh: selected.price / 2,
                            shekel: true,
                            label: "תשלום סוף תקופה (בלון)",
                            formik: formik,
                            id: "endOfPeriodPayment",
                            handleChange: handleChange,
                            optional: true,
                            toolTipText: "מסלול מימון המשלב תשלום מקדמה, פריסת תשלומים חודשית ותשלום היתרה בסוף התקופה או בחינת יצירת עסקת טרייד אין להחלפת הרכב ברכב חדש."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(finance_LoanDetails, {
                            data: bottomData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(finance_BottomActions, {
                            onCopyOpen: handleCopyOpen,
                            onTermsOpen: handleTermsOpen,
                            onContactOpen: handleContactOpen
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var finance = (Finance);


/***/ }),

/***/ 24184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopUp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29525);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55761);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiDialog-paperWidthSm {\n    border-radius: 8px;\n    overflow: hidden;\n    margin: 0 20px;\n  }\n  .MuiBackdrop-root {\n    background: rgba(16, 16, 16, 0.5);\n    webkit-backdropfilter: blur(0px);\n    backdrop-filter: blur(0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  padding: 0px;\n  color: ",
        ";\n  &:hover {\n    background-color: transparent;\n  }\n  ",
        " {\n    top: 5.25px;\n    right: 15.25px;\n    z-index: 10;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow-y: scroll;\n  padding: 30px !important;\n\n  ",
        " {\n    padding: 20px !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 22.4px;\n  ",
        " {\n    font-family: OENaPro;\n    font-weight: 400;\n    font-size: 24px;\n    line-height: 33.6px;\n    letter-spacing: 0.8px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 130%;\n  margin: 0 10px;\n\n  text-align: center;\n\n  color: #616161;\n  margin-top: 15.5px;\n\n  ",
        " {\n    margin: 0 30px;\n    margin-top: 15.5px;\n\n    font-style: normal;\n    font-weight: 300;\n    font-size: 12px;\n    line-height: 130%;\n\n    text-align: center;\n\n    color: #616161;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  color: #999999;\n  background-color: transparent;\n  border: none;\n  font-size: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: OENaPro;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 130%;\n  margin: 0 10px;\n\n  text-align: center;\n\n  color: ",
        ";\n\n  ",
        " {\n    margin: 0 30px;\n\n    font-style: normal;\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 130%;\n\n    text-align: center;\n\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledDialog",
    componentId: "sc-ec9d74b2-0"
})(_templateObject());
var StyledContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledContent",
    componentId: "sc-ec9d74b2-1"
})(_templateObject1());
var StyledCloseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "PopUp__StyledCloseButton",
    componentId: "sc-ec9d74b2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledScrollable = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledScrollable",
    componentId: "sc-ec9d74b2-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledHeaderContainer",
    componentId: "sc-ec9d74b2-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledSubHeaderContainer",
    componentId: "sc-ec9d74b2-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "PopUp__StyledButton",
    componentId: "sc-ec9d74b2-6"
})(_templateObject6());
var StyledDarkSubHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "PopUp__StyledDarkSubHeaderContainer",
    componentId: "sc-ec9d74b2-7"
})(_templateObject7(), function(p) {
    return p.theme.colors.black;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.colors.black;
});
function PopUp(param) {
    var setOpen = param.setOpen, open = param.open, children = param.children, header = param.header, maxWidth = param.maxWidth, width = param.width, customClose = param.customClose, subHeader = param.subHeader, darkSubHeader = param.darkSubHeader;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSubHeaderOpen = ref[0], setIsSubHeaderOpen = ref[1];
    var handleClose = function() {
        customClose ? customClose() : setOpen(false);
    };
    var handleSubClick = function() {
        setIsSubHeaderOpen(!isSubHeaderOpen);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDialog, {
        maxWidth: maxWidth,
        onClose: handleClose,
        "aria-labelledby": "customized-dialog-title",
        open: open,
        style: width ? {
            width: width,
            margin: "auto"
        } : null,
        "aria-modal": "true",
        tabIndex: -1,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContent, {
            children: [
                header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeaderContainer, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyCenter */ .kc, {
                            variant: "h2",
                            $fontSize: "24px",
                            $fontWeight: "400",
                            children: header
                        }),
                        subHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                            onClick: handleSubClick,
                            "aria-expanded": isSubHeaderOpen ? true : false,
                            "aria-label": "מידע נוסף",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                fontSize: "inherit",
                                style: {
                                    color: "#616161",
                                    fill: "#616161"
                                }
                            })
                        })
                    ]
                }),
                darkSubHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDarkSubHeaderContainer, {
                    children: darkSubHeader
                }),
                subHeader && isSubHeaderOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubHeaderContainer, {
                    children: subHeader
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCloseButton, {
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledScrollable, {
                    children: children
                })
            ]
        })
    });
}


/***/ })

}]);